import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {
  START_DATE,
  END_DATE,
  ICON_AFTER_POSITION,
  HORIZONTAL_ORIENTATION,
  VERTICAL_ORIENTATION
} from 'react-dates/constants';
import { DateRangePicker, DayPickerRangeController } from 'react-dates';
import { getUserType } from '../../common/utils/cookie-utils';

import { StateExporter } from '../../containers/CMDashboard/CMDashboard';
import { StateExporterRm } from '../../containers/RMDashboard/RmDashboard';
import { StateExporterPtn } from '../../containers/PartnerDashboard/PartnerDashboard';
import { StateExporterCallDetails } from '../../containers/CallDetails/CallDetails';
import { StateExporterBp } from '../../containers/AdminDashboard/AdminDashboard';

import './DashboardDateFilter.css';

var stringToHTML = function(str) {
  appendElement.current.innerHTML = str;
};

const DashboardDateFilter = ({
  setFlexTimeLine,
  setToggleDateOptions,
  vertical,
  focusedInputProp,
  fromDate = moment().format('YYYY-MM-DD'),
  toDate = moment().format('YYYY-MM-DD'),
  setFromDate,
  setToDate,
  user,
  getValuesByProps = false,
  ...props
}) => {
  const stateImporter = useContext(StateExporter);
  const stateExporterRm = useContext(StateExporterRm);
  const stateExporterPtn = useContext(StateExporterPtn);
  const stateExporterCallDetails = useContext(StateExporterCallDetails);
  const stateExporterBp = useContext(StateExporterBp);

  let userType = getUserType();
  if (stateExporterCallDetails && stateExporterCallDetails?.CallDetails)
    userType = 3; // for callDetails container
  if (stateExporterBp?.bp) userType = 4;

  const contextTypeDecider = () => {
    switch (parseInt(userType)) {
      case 0:
        return stateExporterPtn;

      case 1:
        if (user == 'rm') return stateImporter;
        else return stateExporterRm;
      case 2:
        return stateImporter;
      case 3:
        return stateExporterCallDetails;
      case 4:
        return stateExporterBp;
      default:
        return null;
    }
  };
  const { startDate, endDate, setStartDate, setEndDate } = getValuesByProps
    ? props
    : {
        startDate:
          typeof contextTypeDecider() == 'object'
            ? contextTypeDecider().startDate
            : fromDate,
        endDate:
          typeof contextTypeDecider() == 'object'
            ? contextTypeDecider().endDate
            : toDate,
        setStartDate:
          typeof contextTypeDecider() == 'object'
            ? contextTypeDecider().setStartDate
            : setFromDate,
        setEndDate:
          typeof contextTypeDecider() == 'object'
            ? contextTypeDecider().setEndDate
            : setToDate
      };

  const [width, setWidth] = useState(window.innerWidth);
  const [focusedInput, setFocusedInput] = useState(
    focusedInputProp ? START_DATE : null
  );

  const handleWindowResize = () => setWidth(window.innerWidth);
  const refEndDate = endDate;

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <>
      <DateRangePicker
        startDate={moment(startDate)} // momentPropTypes.momentObj or null,moment(startDate).format('YYYY-MM-DD')
        startDateId={START_DATE} // PropTypes.string.isRequired,
        endDate={moment(endDate)} // momentPropTypes.momentObj or null,
        endDateId={END_DATE} // PropTypes.string.isRequired,
        onDatesChange={({ startDate, endDate }) => {
          {
            startDate
              ? setStartDate(startDate.format('YYYY-MM-DD'))
              : setStartDate(moment().format('YYYY-MM-DD'));
          }
          {
            endDate
              ? setEndDate(endDate.format('YYYY-MM-DD'))
              : setEndDate(moment().format('YYYY-MM-DD'));
          }
        }} // PropTypes.func.isRequired,
        onClose={() => {
          if (setFlexTimeLine) {
            // setFlexTimeLine(false);
            setToggleDateOptions(false);
            setFlexTimeLine(true);
          }
        }}
        minimumNights={0}
        displayFormat="DD-MM-YYYY"
        orientation={
          vertical
            ? VERTICAL_ORIENTATION
            : width < 768
            ? VERTICAL_ORIENTATION
            : HORIZONTAL_ORIENTATION
        }
        showDefaultInputIcon={true}
        showClearDates={true}
        inputIconPosition={ICON_AFTER_POSITION}
        isOutsideRange={() => false}
        hideKeyboardShortcutsPanel={true}
        focusedInput={focusedInput}
        onFocusChange={focusedInput => setFocusedInput(focusedInput)}
        startDatePlaceholderText={startDate ? startDate : 'Start date'}
        endDatePlaceholderText={endDate ? endDate : 'End date'}
      />
    </>
  );
};
export default DashboardDateFilter;
